import * as types from '../../../../types/masters/stoneAttribute/stoneColor/stoneColorTypes';
import * as api from '../../../../../api/masters/stoneAttribute/stoneColor/stoneColorApi';

export const fetchStoneColors = () => async (dispatch) => {
  dispatch({ type: types.FETCH_STONE_COLOR_REQUEST });
  try {
    const data = await api.fetchStoneColors();
    dispatch({ type: types.FETCH_STONE_COLOR_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_STONE_COLOR_FAILURE, payload: error.message });
  }
};

export const addStoneColor = (stoneColor) => async (dispatch) => {
  try {
    const res = await api.addStoneColor(stoneColor);
    dispatch({ type: types.ADD_STONE_COLOR_SUCCESS, payload: res });
    dispatch(fetchStoneColors());
  } catch (error) {
    dispatch({ type: types.STONE_COLOR_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateStoneColor = (id, stoneColor) => async (dispatch) => {
  try {
    console.log('Updating stone color with ID:', id, 'Data:', stoneColor);
    const res = await api.updateStoneColor(id, stoneColor);
    console.log('Update response:', res);
    dispatch({ type: types.UPDATE_STONE_COLOR_SUCCESS, payload: res });
    dispatch(fetchStoneColors());
  } catch (error) {
    console.error('Update error:', error);
    dispatch({ type: types.STONE_COLOR_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteStoneColor = (id) => async (dispatch) => {
  try {
    await api.deleteStoneColor(id);
    dispatch({ type: types.DELETE_STONE_COLOR_SUCCESS, payload: id });
    dispatch(fetchStoneColors());
  } catch (error) {
    dispatch({ type: types.STONE_COLOR_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setStoneColorEdit = (stoneColor) => ({
  type: types.SET_STONE_COLOR_EDIT,
  payload: stoneColor,
});

export const clearStoneColorEdit = () => ({
  type: types.CLEAR_STONE_COLOR_EDIT,
}); 